var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.messageType
    ? _c("div", { staticClass: "message", class: _vm.messageTypeClass }, [
        _vm._v(_vm._s(_vm.message)),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }